'use client';

import { ComponentType } from 'react';
import { I18nProvider } from '@fshr/context/i18n-context';
import { type FSLocale } from '@fshr/shared';
import { TealiumProvider } from '@fshr/context/tealium-context';

type I18nWrapProps = {
	translations: Record<string, string>;
	locale: FSLocale;
};

export const contextWrap = <P extends object>(Component: ComponentType<P>) => {
	return ({ translations, locale, ...props }: I18nWrapProps & P) => (
		<I18nProvider translations={translations} locale={locale}>
			<TealiumProvider>
				<Component {...(props as P)} />
			</TealiumProvider>
		</I18nProvider>
	);
};
